import React from 'react';
import './styles.scss';
import Report from '../../assets/svg/report.svg';
import {ReactComponent as GitHubIcon} from '../../assets/svg/github.svg';

import Specifications from '../../assets/pdf/specifications.pdf';
import Report1 from '../../assets/pdf/report1.pdf';
import Report2 from '../../assets/pdf/report2.pdf';
import Report3 from '../../assets/pdf/report3.pdf';

export default function(props) {
    return (
        <div className="section reports">
            <h1>Reports</h1>
            <img className="report" src={Report}/>

            <div className="reports-list">
                <div className="report-btn">
                    <h3>Specifications</h3>
                    <a className="button" href={Specifications}>Download</a>
                </div>
                <div className="report-btn">
                    <h3>Report #1</h3>
                    <a className="button" href={Report1}>Download</a>
                </div>
                <div className="report-btn">
                    <h3>Report #2</h3>
                    <a className="button" href={Report2}>Download</a>
                </div>
                <div className="report-btn">
                    <h3>Report #3</h3>
                    <a className="button" href={Report3}>Download</a>
                </div>
            </div>

        </div>
    )
}